<div class="row mt-4 mb-4 map-row">
    <div class="col-12 w-full">
        <div class="w-full h-full map-container">
            <google-map class="w-full h-full" [center]="$any(position())" [zoom]="15"
                width="100%">
                <map-marker [position]="$any(position())"></map-marker>
            </google-map>
        </div>
    </div>
</div>